export default "__VITE_PUBLIC_ASSET__3b801f4c__"